module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if ( itemsCount ) { 
__p+='\n	<h3 class="count">'+
((__t=( paginationInfo ))==null?'':__t)+
'</h3>\n';
 } 
__p+='\n\n<div class="favorites-list">\n\n	';
 if ( itemsCount ) { 
__p+='\n		';
 _.each(items, function(item) { 
__p+='\n			<div class="favorites-item">\n				<div class="image" onclick="location.href=\''+
((__t=( item.url ))==null?'':__t)+
'\'">\n					';
 if ( item.image ) { 
__p+='<img src="//tramino.s3.amazonaws.com'+
((__t=( item.image ))==null?'':__t)+
'" width="100" height="60"/>';
 } 
__p+='\n				</div>\n				<div class="info">\n					<h5><a href="'+
((__t=( item.url ))==null?'':__t)+
'">'+
((__t=( item.name ))==null?'':__t)+
'</a></h5>\n				</div>\n				<div data-id="'+
((__t=( item.id ))==null?'':__t)+
'" class="items-remove" title="'+
((__t=( __('remove') ))==null?'':__t)+
'">&times;</div>\n			</div>\n		';
 }); 
__p+='\n	';
 } else { 
__p+='\n		<div class="notification">'+
((__t=( text_not_found ))==null?'':__t)+
'</div>\n	';
 } 
__p+='\n	\n	<div class="clear"></div>\n\n</div>\n\n<div class="paginator">\n	';
 if ( hasNext ) { 
__p+='<a href="#" class="items-next">'+
((__t=( __('next') ))==null?'':__t)+
' &rarr;</a>';
 } 
__p+='\n	';
 if ( hasPrev ) { 
__p+='<a href="#" class="items-prev">&larr; '+
((__t=( __('prev') ))==null?'':__t)+
'</a>';
 } 
__p+='	\n</div>\n';
}
return __p;
};


/*****************
 ** WEBPACK FOOTER
 ** /Users/mitch/jsapps/modules/reserva/templates/header/favorites-template.html
 ** module id = 52
 ** module chunks = 0
 **/